import type { DriveTargetFolder } from './driveTargetFolder';

const FOLDER_MIME = 'application/vnd.google-apps.folder';

export interface PickDriveFolderOptions {
  token: string;
  apiKey: string;
  appId: string;
  locale?: string;
}

function ensurePickerLoaded(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined' || !window.gapi) {
      reject(new Error('Google API が読み込まれていません。ページを再読み込みしてください'));
      return;
    }
    if (typeof google !== 'undefined' && google.picker) {
      resolve();
      return;
    }
    window.gapi.load('picker', () => resolve());
  });
}

export async function pickDriveFolder(
  opts: PickDriveFolderOptions,
): Promise<DriveTargetFolder | null> {
  await ensurePickerLoaded();

  return new Promise((resolve, reject) => {
    try {
      const view = new google.picker.DocsView()
        .setParent('root')
        .setIncludeFolders(true)
        .setSelectFolderEnabled(true)
        .setMimeTypes(FOLDER_MIME)
        .setMode(google.picker.DocsViewMode.LIST);

      const pickerWidth = Math.min(window.innerWidth - 20, 1051);
      const pickerHeight = Math.min(window.innerHeight - 80, 650);

      const picker = new google.picker.PickerBuilder()
        .addView(view)
        .setAppId(opts.appId)
        .setOAuthToken(opts.token)
        .setDeveloperKey(opts.apiKey)
        .setOrigin(window.location.origin)
        .setLocale(opts.locale ?? 'ja')
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .setSize(pickerWidth, pickerHeight)
        .setCallback((data) => {
          if (data.action === google.picker.Action.PICKED) {
            const doc = data.docs[0];
            resolve({ id: doc.id, name: doc.name });
          } else if (data.action === google.picker.Action.CANCEL) {
            resolve(null);
          }
        })
        .build();

      picker.setVisible(true);
    } catch (err) {
      reject(err instanceof Error ? err : new Error('Picker の起動に失敗しました'));
    }
  });
}
